import { ConcreteEncodable } from "./ConcreteEncodable";

import { SwapDetailsImplEncoder } from "../../encoder/SwapDetailsImplEncoder";

import * as CubiqTS from "../../index";
import { SwapDetails } from "../SwapDetails";

export class SwapDetailsImpl extends ConcreteEncodable implements SwapDetails {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.SwapDetailsImpl";

  /*FID=100*/
  public messageId: string;
  /*FID=941*/
  public swpSettleTenor: CubiqTS.Tenor;
  /*FID=942*/
  public swpSettleDate: CubiqTS.moment.Moment | null = null;
  /*FID=944*/
  public swapPoints: CubiqTS.BigNumber | null = null;
  /*FID=945*/
  public orderQty: CubiqTS.BigNumber | null = null;
  /*FID=946*/
  public settleQty: CubiqTS.BigNumber | null = null;
  /*FID=947*/
  public leavesQty: CubiqTS.BigNumber | null = null;
  /*FID=948*/
  public leavesSettleQty: CubiqTS.BigNumber | null = null;
  /*FID=949*/
  public usdEquivQty: CubiqTS.BigNumber | null = null;
  /*FID=950*/
  public usdEquivLeavesQty: CubiqTS.BigNumber | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SwapDetailsImplEncoder.Instance;
    this.setEncodableType(SwapDetailsImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SwapDetailsImpl[" +
      "messageId=" +
      this.messageId +
      "swpSettleTenor=" +
      this.swpSettleTenor +
      "swpSettleDate=" +
      this.swpSettleDate +
      "swapPoints=" +
      this.swapPoints +
      "orderQty=" +
      this.orderQty +
      "settleQty=" +
      this.settleQty +
      "leavesQty=" +
      this.leavesQty +
      "leavesSettleQty=" +
      this.leavesSettleQty +
      "usdEquivQty=" +
      this.usdEquivQty +
      "usdEquivLeavesQty=" +
      this.usdEquivLeavesQty +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
